import type { ChartType } from '../../api/types'
import { CHART_TYPE_LABELS, genreOptions, PLATFORM_LABELS, useMeta } from '../../hooks/useMeta'
import { Segmented } from '../Segmented'

export interface ChartSelection {
	platform: string
	storefront: string
	genre: number
	type: ChartType
}

const PLATFORMS = ['iphone', 'ipad', 'mac', 'appletv', 'watch']

export function ChartPickers({
	value,
	onChange,
	showGenre = true,
	showType = true,
}: {
	value: ChartSelection
	onChange(v: ChartSelection): void
	showGenre?: boolean
	showType?: boolean
}) {
	const { data: meta } = useMeta()
	const genres = genreOptions(meta, value.platform)
	return (
		<div className="row">
			<Segmented
				label="Platform"
				value={value.platform}
				options={PLATFORMS.map((p) => ({ value: p, label: PLATFORM_LABELS[p] }))}
				onChange={(platform) => onChange({ ...value, platform })}
			/>
			<select
				aria-label="Country"
				value={value.storefront}
				onChange={(e) => onChange({ ...value, storefront: e.target.value })}
			>
				{meta?.storefronts.map((s) => (
					<option key={s.code} value={s.code}>
						{s.name}
					</option>
				))}
			</select>
			{showGenre && (
				<select
					aria-label="Category"
					value={value.genre}
					onChange={(e) => onChange({ ...value, genre: Number(e.target.value) })}
				>
					{genres.map((g) => (
						<option key={g.id} value={g.id}>
							{g.label}
						</option>
					))}
				</select>
			)}
			{showType && (
				<Segmented
					label="Chart"
					value={value.type}
					options={(value.platform === 'watch'
						? (['free', 'paid'] as const)
						: (['free', 'paid', 'grossing'] as const)
					).map((t) => ({ value: t, label: CHART_TYPE_LABELS[t] }))}
					onChange={(type) => onChange({ ...value, type })}
				/>
			)}
		</div>
	)
}
